import { UrlMatcher, UrlSegment } from '@angular/router';

const PAGES_SEGMENT = 'pages';
const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Matches exactly `pages/<kind>/<guid>` and exposes the GUID as the `key` route param. */
export function shareKeyMatcher(kind: string): UrlMatcher {
  return (segments: UrlSegment[]) => {
    const [section, kindSegment, key] = segments;
    if (segments.length !== 3 || section.path !== PAGES_SEGMENT || kindSegment.path !== kind || !GUID_PATTERN.test(key.path)) {
      return null;
    }
    return { consumed: segments, posParams: { key } };
  };
}
